module.exports = __webpack_public_path__ + "img/icon-activity-call-active.ed9720a0.svg";